export default {
  register: 'api/auth/agent/register',
  login: 'api/auth/login',
  self: 'api/users/me',
  refreshToken: 'api/auth/refresh_token',
  leads: {},
};
